<template lang="pug">
  #ReservationEdit.container-width
    h5.text-center.pt-2 修改預約
    .p-3
      .mb-2
        ValidationObserver(
          ref="form"
          tag="form"
          @submit.stop.prevent="submitHandler"
        )
          b-form-group
            ValidationProvider(
              rules="required",
              ref="inputValName"
            )
              label(
                for="name"
              )
                code *
                span 顧客姓名：
              b-form-input(
                id="name",
                type="text",
                required,
                trim,
                :state="validState('name')",
                v-model="form.name",
                aria-describedby="input-live-help input-name-live-feedback",
                placeholder="請輸入顧客姓名",
                :disabled="true"
              )
              b-form-invalid-feedback(
                id="input-name-live-feedback"
              )
                span 此欄不可為空
          b-form-group
            ValidationProvider(
              rules="required",
              ref="inputValService",
              v-slot="{ errors }"
            )
              label(
                for="store"
              )
                code *
                span 預約服務
              b-form-select(
                id="store",
                required,
                v-model="form.service",
                :state="validState('service')",
                aria-describedby="input-live-help input-name-live-feedback",
                placeholder="請選擇預約服務"
              )
                template(
                  v-slot:first
                )
                  b-form-select-option(
                    :value="null",
                    disabled
                  ) 請選擇預約服務
                  b-form-select-option.d-none(
                    :value="''",
                    disabled
                  ) 請選擇預約服務
                b-form-select-option(
                  v-for="(service,index) in reservationsTypeList",
                  :key="service.id",
                  :value="service.id"
                ) {{ service.name }}
              b-form-invalid-feedback(
                id="input-name-live-feedback"
              )
                span 此欄不可為空
          b-form-group
            ValidationProvider(
              rules="required",
              ref="inputValDate"
            )
              label(
                for="date"
              )
                code *
                span 預約日期
              b-form-datepicker(
                id="date",
                type="date",
                required,
                trim,
                :state="validState('date')",
                v-model="form.date",
                aria-describedby="input-live-help input-name-live-feedback",
                placeholder="請選擇預約日期",
                :min="dateMinLimit"
              )
              b-form-invalid-feedback(
                id="input-name-live-feedback"
              )
                span 此欄不可為空
          b-form-group
            ValidationProvider(
              rules="required",
              ref="inputValTimeId"
            )
              label(
                for="timeId"
              )
                code *
                span 預約時間
              multiselect(
                v-model="form.timeId",
                tag-placeholder="輸入搜尋預約時間",
                placeholder="請選擇預約時間",
                selectedLabel="已選擇",
                selectLabel="點擊新增預約時間",
                label="start_time",
                track-by="id"
                :custom-label="nameWithTimeId"
                :options="reservationTimeList",
                :allow-empty="false"
                noOptions="無預約時間"
              )
                template(slot="noOptions")
                  strong 無預約時間
          b-form-group
            ValidationProvider(
              ref="inputValMemberNote"
            )
              label(
                for="memberNote"
              )
                span 顧客備註
              b-form-textarea(
                id="memberNote",
                type="text",
                rows="3",
                v-model="form.memberNote",
                placeholder="輸入備註",
                :disabled="true"
              )
          b-form-group
            ValidationProvider(
              ref="inputValSaNote"
            )
              label(
                for="saNote"
              )
                span 顧問備註
              b-form-textarea(
                id="saNote",
                type="text",
                rows="3",
                v-model="form.saNote",
                placeholder="輸入備註"
              )
      .px-4
        .row
          .col-6
            b-button(
              block,
              variant="primary"
            )
              router-link.text-white(
                :to="{ name: 'sa-reservation-index' }"
              ) 取消
          .col-6
            button.btn.btn-block.btn-primary.text-center(
              type="button",
              @click="submitHandler()"
            ) 確認
</template>

<script>
import { mapState } from 'vuex';
import { SA_RESERVATION_INDEX } from '@/router/sa/reservation';
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate'; // 檢查套件
import { required } from 'vee-validate/dist/rules';

const moment = require('moment');
const _ = require('lodash');

// 獲取所有驗證條件
extend('required', {
  ...required,
  message: '此欄不可為空'
});

export default {
  name: 'ReservationEdit',
  components: {
    ValidationProvider,
    ValidationObserver
  },
  props: {
    id: {
      type: [String, Number],
      required: true
    },
    editInfo: {
      type: Object,
      required: true
    }
  },
  data() {
    const now = new Date();
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const minDate = new Date(today);
    return {
      form: {
        name: null,
        service: null,
        date: null,
        timeId: null,
        memberNote: null,
        saNote: null
      },
      dateMinLimit: minDate
    };
  },
  created() {
    const vm = this;
    vm.$swal.fire({
      title: '載入中，請稍候',
      allowOutsideClick: false,
      willOpen: () => {
        vm.$swal.showLoading();
      }
    });

    // 塞回資料
    vm.form.name = vm.editInfo.line_name;
    vm.form.service = vm.editInfo.reserve_type_id;
    vm.form.date = vm.editInfo.reserve_date;
    const timeIdKey = _.findKey(vm.reservationTimeList, (val) => val.id === vm.editInfo.reservation_period_id);
    vm.form.timeId = vm.reservationTimeList[timeIdKey];
    vm.form.memberNote = vm.editInfo.m_note;
    vm.form.saNote = vm.editInfo.p_note;

    // 取得預約服務選項
    vm.$store.dispatch('sa_reservation/getReservationTypeListHandler')
      .then(() => {
        vm.$swal.close();
      });
  },
  methods: {
    nameWithTimeId({ start_time, end_time }) {
      return `${start_time}~${end_time}`;
    },
    moment() {
      return moment();
    },
    // 檢查欄位
    validState(key) {
      const vm = this;
      // 其餘統一判斷
      if (vm.form[key] !== null) {
        return this.form[key] ? true : false;
      }
      return null;
    },
    // 送出表單
    async submitHandler() {
      const vm = this;
      const isValid = await this.$refs.form.validate();
      if (!isValid) {
        if (vm.form.name === null) {
          vm.form.name = '';
        }
        if (vm.form.service === null) {
          vm.form.service = '';
        }
        if (vm.form.date === null) {
          vm.form.date = '';
        }
        if (vm.form.timeId === null) {
          vm.form.timeId = '';
        }
        vm.$swal.fire({
          icon: 'error',
          title: '請填妥必填欄位或格式輸入錯誤'
        });
      } else {
        const key = _.findKey(vm.reservationTimeList, (val) => val.id === vm.form.timeId.id);
              const now = moment().format('hh:mm');
              const beginTime = moment(vm.reservationTimeList[key].start_time, 'hh:mma');
              const endTime = moment(now, 'hh:mma');
              const today = moment().format('YYYY-MM-DD');
              const reservationDate = moment(vm.form.date).format('YYYY-MM-DD');

        if (moment(reservationDate).isBefore(today)) {
          vm.$swal.fire({
            icon: 'error',
            title: '預約時間不可小於目前日期'
          });
        } else if (vm.form.date === moment().format('YYYY-MM-DD') && beginTime.isBefore(endTime)) {
          vm.$swal.fire({
            icon: 'error',
            title: '預約時間不可小於目前時間'
          });
        } else {
          vm.$swal.fire({
            title: '表單送出中，請稍候',
            allowOutsideClick: false,
            willOpen: () => {
              vm.$swal.showLoading();
            }
          });

          const sendData = {
            reservation_id: vm.editInfo.reservation_id,
            reservation_type_id: vm.form.service,
            date: vm.form.date,
            reservation_period_id: vm.form.timeId.id,
            p_note: vm.form.saNote
          };

          vm.$store.dispatch('sa_reservation/updateReservationHandler', sendData)
            .then(() => {
              vm.$swal.close();
              vm.$snotify.success(null, '修改成功');
              vm.$router.push({
                name: SA_RESERVATION_INDEX
              });
            });
        }
      }
    }
  },
  computed: {
    ...mapState({
      reservationsTypeList: (state) => state.sa_reservation.reservationsTypeList,
      reservationTimeList: (state) => state.sa_reservation.reservationTimeList
    })
  }
};
</script>

<style>

</style>
